import { render } from "./MobileSubscription.vue?vue&type=template&id=3bc4c09b&ts=true"
import script from "./MobileSubscription.vue?vue&type=script&lang=ts"
export * from "./MobileSubscription.vue?vue&type=script&lang=ts"

import "./MobileSubscription.vue?vue&type=style&index=0&id=3bc4c09b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__